<div [formGroup]="form">
  <div class="card-form-group-container">
    <mat-form-field>
      <input
        matInput
        placeholder="Unità di misura (MISU)"
        formControlName="MISU">
    </mat-form-field>
    <mat-form-field appearance="fill" floatLabel="always">
      <mat-label>Altezza (MISA)</mat-label>
      <input
        matInput
        placeholder="Altezza (MISA)"
        decimalMarker=","
        thousandSeparator="."
        mask="separator.2"
        formControlName="MISA">
    </mat-form-field>
    <mat-form-field appearance="fill" floatLabel="always">
      <mat-label>Larghezza (MISL)</mat-label>
      <input
        matInput
        placeholder="Larghezza (MISL)"
        decimalMarker=","
        thousandSeparator="."
        mask="separator.2"
        formControlName="MISL">
    </mat-form-field>
    <mat-form-field *ngIf="form?.controls?.MISP" appearance="fill" floatLabel="always">
      <mat-label>Profondità (MISP)</mat-label>
      <input
        matInput
        placeholder="Profondità (MISP)"
        decimalMarker=","
        thousandSeparator="."
        mask="separator.2"
        formControlName="MISP">
    </mat-form-field>
    <mat-form-field *ngIf="form?.controls?.MISD" appearance="fill" floatLabel="always">
      <mat-label>Diametro (MISD)</mat-label>
      <input
        matInput
        placeholder="Diametro (MISD)"
        decimalMarker=","
        thousandSeparator="."
        mask="separator.2"
        formControlName="MISD">
    </mat-form-field>
    <mat-form-field *ngIf="form?.controls?.MIST" appearance="fill" floatLabel="always">
      <mat-label>Validità (aaaa?-mm?-gg) (MIST)</mat-label>
      <input
        matInput
        placeholder="Validità (aaaa?-mm?-gg) (MIST)"
        formControlName="MIST">
      <mat-error *ngIf="form?.controls?.MIST?.hasError('iccdDate')">
        {{ 'Formato data non conforme allo standard ICCD' | translate }}
      </mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="form?.controls?.MISR" appearance="fill" floatLabel="always">
      <mat-label>Mancanza (MISR)</mat-label>
      <input
        matInput
        placeholder="Mancanza (MISR)"
        formControlName="MISR">
    </mat-form-field>
    <mat-form-field *ngIf="form?.controls?.MISG" appearance="fill" floatLabel="always">
      <mat-label>Peso (MISG)</mat-label>
      <input
        matInput
        placeholder="Peso (MISG)"
        decimalMarker=","
        thousandSeparator="."
        mask="separator.2"
        formControlName="MISG">
      <span matSuffix>&nbsp;Kg</span>
    </mat-form-field>
    <mat-form-field *ngIf="form?.controls?.MISN" appearance="fill" floatLabel="always">
      <mat-label>Lunghezza (MISN)</mat-label>
      <input
        matInput
        placeholder="Lunghezza (MISN)"
        decimalMarker=","
        thousandSeparator="."
        mask="separator.2"
        formControlName="MISN">
    </mat-form-field>
    <mat-form-field *ngIf="form?.controls?.MISS" appearance="fill" floatLabel="always">
      <mat-label>Spessore (MISS)</mat-label>
      <input
        matInput
        placeholder="Spessore (MISS)"
        decimalMarker=","
        thousandSeparator="."
        mask="separator.2"
        formControlName="MISS">
    </mat-form-field>
    <mat-form-field *ngIf="form?.controls?.MISB" appearance="fill" floatLabel="always">
      <mat-label>(MISB)</mat-label>
      <input
        matInput
        placeholder="(MISB)"
        formControlName="MISB">
    </mat-form-field>
    <mat-form-field *ngIf="form?.controls?.MISI" appearance="fill" floatLabel="always">
      <mat-label>(MISI)</mat-label>
      <input
        matInput
        placeholder="(MISI)"
        formControlName="MISI">
    </mat-form-field>
    <ng-container *ngIf="form?.controls?.MISO">
      <app-input-vocabulary-autocomplete
        formControlName="MISO"
        [vocabularyName]="'V_F_MISO'"
        [placeholder]="'Tipo di misure (MISO)'">
      </app-input-vocabulary-autocomplete>
    </ng-container>
  </div>

  <div
    *ngIf="form?.controls?.MISV"
    formArrayName="MISV">
    <div
      class="repeatable-card-field"
      *ngFor="let misv of misvs; let i = index">
      <mat-form-field>
        <input
          matInput
          placeholder="Varie (MISV)"
          [formControlName]="i">
      </mat-form-field>
      <button
        *roleVisibility="['create', 'update']; classNames: classNames"
        mat-icon-button
        type="button"
        (click)="removeMISVHandler(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    <button
      *roleVisibility="['create', 'update']; classNames: classNames"
      mat-raised-button
      type="button"
      (click)="addMISVHandler()">
      {{ 'Aggiungi varie (MISV)' | translate }}
    </button>
  </div>
</div>
